import {GlobalVariables} from "../GlobalVariables";

export default class Booking {
	static init() {

		let formBtnOpen = document.querySelectorAll(".form-aside-btn-open");
		let formBtnClose = document.querySelector(".aside-form-close");

		formBtnOpen.forEach( (btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.add('aside-form-opened');
				document.body.classList.remove('navs-open');
				document.body.classList.remove("navs-site-switch-open");
				GlobalVariables.lenis?.stop();
			});
		});

		formBtnClose.addEventListener('click', () => {
			document.body.classList.remove('aside-form-opened');
			GlobalVariables.lenis?.start();
		});

		this.bookingForms = document.querySelectorAll('.booking-form');

		if( this.bookingForms ){

			this.bookingForms.forEach( (booking) => {

				let form = booking;
				let select = booking.querySelector('select[name="hotelid"]');
				select.addEventListener('change', () => {
					form.action = select.value;
				});

				form.addEventListener('submit', (e) => {
					e.preventDefault();
					const formData = new FormData(form);  // Récupère toutes les données du formulaire
					let hotelId = '';

					const params = new URLSearchParams();
					formData.forEach((value, key) => {
						if( key === "hotelid" ){
							hotelId = value;
						}
						if( key !== "dateinFake" && key !== "dateoutFake" && key !== "hotelid"  ){
							params.append(key, value);
						}
					});

					let url = "https://reservations.travelclick.com/" + hotelId + '?' + params.toString();
					console.log(url);
					window.open(url);
				});

				let dateIn = booking.querySelector("input[name='datein']");
				let dateOut = booking.querySelector("input[name='dateout']");
				let dateInFake = booking.querySelector("input[name='dateinFake']");
				let dateOutFake = booking.querySelector("input[name='dateoutFake']");

				dateInFake.addEventListener('change', () => {
					if (dateInFake.value) {
						dateIn.value = this.dateToFr(dateInFake.value);
						const minEnd = this.addDays(dateInFake.value, 1);
						dateOutFake.min = minEnd;
						if( dateOutFake.value <= minEnd ){
							dateOutFake.value = minEnd;
							dateOut.value = this.dateToFr(minEnd);
						}
					}
				});

				dateOutFake.addEventListener('change', () => {
					if (dateOutFake.value) {
						dateOut.value = this.dateToFr(dateOutFake.value);
					}
				});

				form.querySelectorAll('.form-booking-field').forEach( (field) => {

					field.addEventListener('click', () => {

						let input = field.querySelector('input:not([type="hidden"])');
						if( input ){
							input.focus();
							// Optionnel (Chrome uniquement) :
							if ( input.type === "date" && input.showPicker) {
								input.showPicker(); // fonctionne uniquement si interaction utilisateur
							}
						}

					});
				});


			});

		}

	}

	static addDays(dateStr, days) {
		const date = new Date(dateStr);
		date.setDate(date.getDate() + days);
		return date.toISOString().split('T')[0]; // format YYYY-MM-DD
	}

	static dateToFr(val){
		const date = new Date(val);
		return new Intl.DateTimeFormat('en-EN').format(date);
	}

}
